import {
  collection,
  getDocs,
  query,
  where,
  Timestamp,
} from "firebase/firestore"
import { useEffect, useState } from "react"
import dayjs from "dayjs"
import { db } from "../../Firebase/config"

const UseallOverview = (collection_name, startDate = null, endDate = null) => {
  const [data, setData] = useState([]) // Holds the fetched data
  const [loading, setLoading] = useState(false) // Loading state

  const fetchReservations = async () => {
    setLoading(true)
    try {
      const docRef = collection(db, collection_name)

      // Default to today's date if no startDate or endDate is provided
      const startTimestamp = startDate
        ? Timestamp.fromDate(dayjs(startDate).startOf("day").toDate()) // Start of the day
        : Timestamp.fromDate(dayjs().startOf("day").toDate())
      const endTimestamp = endDate
        ? Timestamp.fromDate(dayjs(endDate).endOf("day").toDate()) // End of the day
        : Timestamp.fromDate(dayjs().endOf("day").toDate())

      // Construct the query based on the date range
      let q
      if (startTimestamp && endTimestamp) {
        q = query(
          docRef,
          where("createdAt", ">=", startTimestamp),
          where("createdAt", "<=", endTimestamp)
        )
      } else if (startTimestamp) {
        q = query(docRef, where("createdAt", ">=", startTimestamp))
      } else if (endTimestamp) {
        q = query(docRef, where("createdAt", "<=", endTimestamp))
      } else {
        q = query(docRef) // Default to fetching all if no filters are applied
      }

      const snapshot = await getDocs(q)

      // Map snapshot to data
      const fetchedData = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }))

      setData(fetchedData) // Update the data state with all matching results
    } catch (error) {
      console.error("Error fetching data:", error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchReservations()
    // eslint-disable-next-line
  }, [startDate, endDate])

  return {
    data,
    loading,
  }
}

export default UseallOverview
